<template>
  <!-- when overview tab is hidden (no description, no naturelynx section), show occurrence map in the ab status map-->
  <ocurrence-map v-if="!toShowOverviewTab && state?.hasOccurrenceMap"/>
  <section id="habSuitability" class="section bgLight pretty-top pretty-bottom" 
  :class="{'pretty-top-light': !toShowOverviewTab, 'pretty-bottom': !toShowOverviewTab}" v-if="state?.hasMap">
    <div class="sectionBg dim map" v-if="toShowOverviewTab"></div>

    <div class="container has-text-centered condensed">
      <div class="columns">
        <div class="column">
          <h2>{{ $t("profile.ABStatus.habSuitability.sectionHeader") }} </h2>
          <div class="profile richtext bold" v-html="sppContent?.WebRange"></div>
        </div>
      </div>
    </div>
    <div class="container">
      <hr/>
      <comparison-map-sub-section />
      <template v-if="false"> <!-- hide show different map text-->
        <hr/>
        <div class="columns is-multiline wideGap">
          <div class="column is-12-tablet">
            <h3>{{ $t("profile.ABStatus.habSuitability.sectionHeader") }} - {{ $t("profile.ABStatus.habSuitability.differentMap.label") }}</h3>
            <div v-html='$t("profile.ABStatus.habSuitability.differentMap.description", {sppName: state?.sppName})'>
            </div>

            <div class="interpretion profile richtext" v-html="sppContent?.WebDifferenceMapText">
            </div>
            <p><a @click="toShowMapDescription = !toShowMapDescription" class="caps">{{ $t("profile.ABStatus.habSuitability.differentMap.interpretHeader", { year: state.sppGroup?.habitatMapYear}) }} <span>{{ toShowMapDescription ? '-': '+'}}</span></a></p>
            <div v-show="toShowMapDescription" v-html="$t('profile.ABStatus.habSuitability.differentMap.detail', { year: state.sppGroup?.habitatMapYear})"></div>
          </div>
        </div>
      </template>
    </div>
  </section>
</template>

<script>
import { useApp } from '@/composables/state/profileState';
import ComparisonMapSubSection from './ComparisonMapSubSection.vue';
import OcurrenceMap from '../../overview/OcurrenceMap.vue';

export default {
  components: { ComparisonMapSubSection, OcurrenceMap },
  name: 'AB-status-map-section',
  setup () {
    const { state, sppContent, toShowOverviewTab } = useApp();
    return {
      state,
      sppContent,
      toShowOverviewTab
    }
  }
}
</script>
<style scoped>
section {
  position: relative;
}
</style>